import { useState } from "react";
import { supabase } from "@/lib/supabase";

interface PasswordFormProps {
  onToast: (msg: string, type?: "success" | "error") => void;
}

export default function PasswordForm({ onToast }: PasswordFormProps) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [updating, setUpdating] = useState(false);

  const handleUpdate = async () => {
    if (!newPassword || !confirmPassword) {
      onToast("請輸入新密碼與確認密碼", "error");
      return;
    }
    if (newPassword !== confirmPassword) {
      onToast("兩次輸入的密碼不一致", "error");
      return;
    }
    if (newPassword.length < 6) {
      onToast("密碼長度至少 6 位", "error");
      return;
    }

    setUpdating(true);
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) {
      onToast("密碼更新失敗：" + error.message, "error");
    } else {
      onToast("密碼更新成功，下次登入請使用新密碼", "success");
      setNewPassword("");
      setConfirmPassword("");
    }
    setUpdating(false);
  };

  const inputClass =
    "w-full px-3 py-2 rounded-lg border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 bg-background-50";

  return (
    <div className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6">
      <h2 className="text-base font-bold text-foreground-900 mb-1">密碼管理</h2>
      <p className="text-xs text-foreground-500 mb-4">建議每 90 天更新一次密碼</p>
      <div className="space-y-3">
        <div>
          <label className="block text-xs text-foreground-600 mb-1.5">新密碼</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className={inputClass}
            placeholder="請輸入新密碼"
          />
        </div>
        <div>
          <label className="block text-xs text-foreground-600 mb-1.5">確認新密碼</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={inputClass}
            placeholder="請再次輸入新密碼"
          />
        </div>
      </div>
      <button
        onClick={handleUpdate}
        disabled={updating}
        className="w-full mt-4 px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-50 whitespace-nowrap"
      >
        {updating ? "更新中..." : "更新密碼"}
      </button>
    </div>
  );
}